import { render, staticRenderFns } from "./cardTemplateVip28.vue?vue&type=template&id=3540e9ee&scoped=true&"
import script from "./cardTemplateVip28.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip28.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip28.vue?vue&type=style&index=0&id=3540e9ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3540e9ee",
  null
  
)

export default component.exports